export const hasValue = customFieldValue => customFieldValue.text !== '';
